module.exports = __webpack_public_path__ + "static/media/lupa.fcffa2eb.svg";